import { useState, useContext } from "react";
import { ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { tokens } from "../../theme";
//import CalculateIcon from "@mui/icons-material/Calculate";
//import EngineeringIcon from "@mui/icons-material/Engineering";
//import DownloadIcon from "@mui/icons-material/Download";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import StyleIcon from '@mui/icons-material/Style';
import ScheduleIcon from "@mui/icons-material/Schedule";
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import GroupIcon from '@mui/icons-material/Group';
import { learncardsContext } from "../../App";

const Item = ({ title, to, icon, selected, setSelected }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    return (
        <MenuItem
            active={selected === title}
            style={{
                color: colors.grey[100],
            }}
            onClick={() => setSelected(title)}
            icon={icon}
        >
            <Typography>{title}</Typography>
            <Link to={to} />
        </MenuItem>
    );
};

const Sidebar = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [isCollapsed, setIsCollapsed] = useState(false);
    const { selected, setSelected } = useContext(learncardsContext);


    return (
        <Box
            sx={{
                "& .pro-sidebar-inner": {
                    background: `${colors.primary[400]} !important`,
                },
                "& .pro-icon-wrapper": {
                    backgroundColor: "transparent !important",
                },
                "& .pro-inner-item": {
                    padding: "5px 35px 5px 20px !important",
                },
                "& .pro-inner-item:hover": {
                    color: "#868dfb !important",
                },
                "& .pro-menu-item.active": {
                    color: "#6870fa !important",
                },
            }}
        >
            <ProSidebar collapsed={isCollapsed}>
                <Menu iconShape="square">
                    {/* LOGO AND MENU ICON */}
                    <MenuItem
                        onClick={() => setIsCollapsed(!isCollapsed)}
                        icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
                        style={{
                            margin: "10px 0 20px 0",
                            color: colors.grey[100],
                        }}
                    >
                        {!isCollapsed && (
                            <Box
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                ml="15px"
                            >

                                <Box display="flex" justifyContent="center" alignItems="center">
                                    {/**/}
                                    <a href="https://memochill.be" target="_blank" rel="noreferrer">
                                        <img
                                            alt="MEMO Chill"
                                            width="120px"
                                            //height="100px"
                                            src={`../../assets/learn.png`}
                                        />
                                    </a>


                                </Box>

                                {/*<Typography variant="h3" color={colors.grey[100]}>
                  Het BijlesBureau
                </Typography>*/}

                                <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                                    <MenuOutlinedIcon />
                                </IconButton>
                            </Box>
                        )}
                    </MenuItem>

                    {/**
          {!isCollapsed && (
            <Box mb="25px">
              <Box textAlign="center"></Box>
              <Box display="flex" justifyContent="center" alignItems="center">
                <img
                  alt="logo"
                  height="50px"
                  src={`../../assets/learn.png`}
                  style={{ cursor: "pointer", borderRadius: "0%" }}
                />
              </Box>
            </Box>
          )}
           */}

                    <Box paddingLeft={isCollapsed ? undefined : "10%"}>
                        <Item
                            title="Oefenen"
                            to="/"
                            icon={<LocalFireDepartmentIcon />}
                            selected={selected}
                            setSelected={setSelected}
                        />
                        <Typography
                            variant="h5"
                            color={colors.grey[300]}
                            sx={{ m: "15px 0 5px 20px" }}
                        >
                            {isCollapsed ? undefined : "Beheer"}
                        </Typography>

                        <Item
                            title="Verzamelingen"
                            to="/sets"
                            icon={<StyleIcon />}
                            selected={selected}
                            setSelected={setSelected}
                        />
                        <Item
                            title="Kaarten"
                            to="/cards"
                            icon={< DashboardCustomizeIcon />}
                            selected={selected}
                            setSelected={setSelected}
                        />
                        <Item
                            title="Gebruikers"
                            to="/users"
                            icon={< GroupIcon />}
                            selected={selected}
                            setSelected={setSelected}
                        />
                    </Box>
                </Menu>
                {!isCollapsed && (
                    <Box
                        display="flex"
                        flexDirection="column" // Set the direction to column
                        justifyContent="center"
                        alignItems="center"
                        style={{
                            marginTop: "auto",
                            marginBottom: "20px",
                            marginRight: "20px",
                        }}
                    >
                        <Typography>Developed by</Typography>
                        <Typography>Stijn</Typography>
                        {/** <a href="https://meeruitjezaak.be" target="_blank" rel="noreferrer">
              <img
                alt="Powered by Stijn Bernaer"
                width="160px"
                //height="100px"
                style={{ marginTop: "10px" }} // Add some top margin for spacing
                src={`../../assets/learn.png`} // Push the "Powered by Bijlesbureau" logo to the bottom
              />
            </a>
            **/}
                    </Box>
                )}
            </ProSidebar>
        </Box>
    );
};

export default Sidebar;